<template>
  <div>
    <label class="selector-label" for="">{{ title }}</label>
    <div class="selector">
      <ul>
        <li v-for="v in val" :key="v.id">
          <span>
            {{ v[selectKey] }}
          </span>
          <span @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>
      <div @click="open" class="background" />
      <span v-if="disabled !== true" @click="open" class="ti-angle-down"></span>
    </div>
    <list-item
      :modal="modal"
      :prefix="prefix"
      :simple="true"
      v-model="val"
      :params="params"
    />
  </div>
</template>
<script>
export default {
  data: () => ({
    // val: null,
  }),

  props: {
    title: {
      default: "",
    },
    modal: {
      default: "",
    },
    disabled: {
      default: false,
    },
    selectKey: {
      default: "title",
    },
    prefix: {
      default: "",
    },
    params: {
      default: function () {
        return {};
      },
    },
    value: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    val: {
      get() {
        if (this.value && this.value.id) {
          return [this.value];
        }
        return [];
      },
      set(val) {
        if (val && val.length) {
          this.$emit("input", val[0]);
        } else {
          this.$emit("input", null);
        }
      },
    },
  },
  components: {
    "list-item": () => import("../Modals/ListItem"),
  },
  methods: {
    open() {
      if (this.disabled === true) {
        return false;
      }
      this.$modal.show(`${this.modal}${this.prefix}`);
    },
    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
};
</script>
<style lang="scss">
.selector {
  position: relative;
  & > .background {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  &-label {
    color: #888;
    font-size: 12px;
  }

  background: #fff;
  min-height: 35px;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  display: flex;
  width: 100%;
  align-items: center;
  text-align: left;
  margin-bottom: 15px;
  & > ul {
    list-style: none;
    padding: 0 0 0 5px;
    margin: 0;
    font-size: 16px;
    width: calc(100% - 40px);
    display: flex;
    flex-wrap: wrap;
    & > li {
      z-index: 9;
      margin: 3px;
      padding: 2px 5px 2px 5px;
      background: #222;
      color: #fff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      & > span {
        cursor: pointer;
        display: block;
        font-size: 14px;
        &:last-child {
          font-size: 12px;
          margin-left: 5px;
          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }
  & > span {
    cursor: pointer;
    display: block;
    width: 40px;
    text-align: center;
    font-size: 7px;
    margin-right: auto;
  }
}
</style>